import app from '../app';
import Modal from '../../common/components/Modal';
import Button from '../../common/components/Button';
import LoadingIndicator from '../../common/components/LoadingIndicator';
import Placeholder from '../../common/components/Placeholder';
import humanTime from '../../common/helpers/humanTime';
/**
 * Lists failed queue jobs with their exception/stack trace, and lets an admin
 * retry or delete them (individually or all at once). Backed by the
 * `queue.failed.*` endpoints, which are driver-agnostic.
 */
export default class FailedJobsModal extends Modal {
  loading = true;
  working = false;
  jobs = [];
  expanded = {};
  className() {
    return 'FailedJobsModal Modal--large';
  }
  title() {
    return app.translator.trans('core.admin.failed_jobs.title');
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  load() {
    this.loading = true;
    return app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/queue/failed'
    }).then(body => {
      this.jobs = body.data;
      this.loading = false;
      m.redraw();
    });
  }
  content() {
    if (this.loading) {
      return m("div", {
        className: "Modal-body"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "Modal-body"
    }, this.jobs.length === 0 ? m(Placeholder, {
      text: app.translator.trans('core.admin.failed_jobs.none')
    }) : m("div", {
      className: "FailedJobsModal-list"
    }, m("div", {
      className: "FailedJobsModal-actions"
    }, m(Button, {
      className: "Button",
      icon: "fas fa-redo",
      loading: this.working,
      onclick: () => this.retryAll()
    }, app.translator.trans('core.admin.failed_jobs.retry_all'))), this.jobs.map(job => this.row(job))));
  }
  row(job) {
    const open = this.expanded[job.id];
    return m("div", {
      className: "FailedJobsModal-job"
    }, m("div", {
      className: "FailedJobsModal-jobHeader"
    }, m("div", {
      className: "FailedJobsModal-jobInfo"
    }, m("div", {
      className: "FailedJobsModal-jobName"
    }, job.name), m("div", {
      className: "FailedJobsModal-jobMeta"
    }, app.translator.trans('core.admin.failed_jobs.meta', {
      queue: m("code", null, job.queue),
      time: humanTime(new Date(job.failed_at))
    }))), m("div", {
      className: "FailedJobsModal-jobControls"
    }, m(Button, {
      className: "Button Button--text",
      icon: open ? 'fas fa-chevron-up' : 'fas fa-chevron-down',
      onclick: () => this.expanded[job.id] = !open
    }, app.translator.trans('core.admin.failed_jobs.details')), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-redo",
      loading: this.working,
      onclick: () => this.retry(job),
      "aria-label": app.translator.trans('core.admin.failed_jobs.retry')
    }), m(Button, {
      className: "Button Button--icon Button--danger",
      icon: "fas fa-trash",
      loading: this.working,
      onclick: () => this.forget(job),
      "aria-label": app.translator.trans('core.admin.failed_jobs.delete')
    }))), open && m("pre", {
      className: "FailedJobsModal-exception"
    }, job.exception));
  }
  retry(job) {
    this.act('POST', `/queue/failed/${job.id}/retry`);
  }
  retryAll() {
    this.act('POST', '/queue/failed/retry');
  }
  forget(job) {
    this.act('DELETE', `/queue/failed/${job.id}`);
  }
  act(method, path) {
    this.working = true;
    return app.request({
      method,
      url: app.forum.attribute('apiUrl') + path
    }).then(() => this.load()).then(() => {
      this.working = false;
      m.redraw();
    }).catch(() => {
      this.working = false;
      m.redraw();
    });
  }
}
flarum.reg.add('core', 'admin/components/FailedJobsModal', FailedJobsModal);